const mixin = {
  data() {
    return {
      Model: {
        managersName: null,
        managersSex: null,
        managersAge: null,
        managersDocumentsType: null,
        managersIdCardNo: null,
        managersPosition: null,
        managersEmail: null,
        managersDocumentsValidity: null,
        managersLanline: null,
        managersMobile: null,
        managersZip: null,
        managersAddress: '',
        relationshipWithOrg: '',
        isManagerValidateForever: false,
      },
      options: {
        scrollToInvalidField: false,
      },
      Fields: [
        {
          type: 'input',
          modelKey: 'managersName',
          label: '姓名',
          props: {
            type: 'text',
            readonly: true,
          },
        },
        {
          type: 'input',
          modelKey: 'managersDocumentsType',
          label: '证件类型',
          props: {
            readonly: true,
            type: 'text',
          },
        },
        {
          type: 'input',
          modelKey: 'managersIdCardNo',
          label: '证件号码',
          props: {
            type: 'text',
            readonly: true,
          },
        },
        {
          modelKey: 'managersDocumentsValidity',
          label: '证件有效期',
          rules: {
            // required: true,
          },
          messages: {
            required: '请选择证件有效期',
          },
        },
        {
          type: 'checkbox',
          modelKey: 'isManagerValidateForever',
          props: {
            option: {
              label: '若为永久有效，请勾选',
            },
            position: 'right',
          },
        },
        {
          type: 'input',
          modelKey: 'managersSex',
          label: '性别',
          props: {
            readonly: true,
            type: 'text',
          },
        },
        {
          type: 'input',
          modelKey: 'managersAge',
          label: '年龄',
          props: {
            readonly: true,
            type: 'text',
          },
        },
        {
          type: 'input',
          modelKey: 'managersPosition',
          label: '职务',
          props: {
            type: 'text',
            clearable: true,
            placeholder: '请输入职务',
          },
          rules: {
            // required: true,
            notWhitespace: true,
            custom: val => val && val.length < 20,
          },
          messages: {
            required: '请输入职务',
            custom: '长度在20字符以内',
          },
        },
        {
          type: 'input',
          modelKey: 'managersEmail',
          label: '电子邮箱',
          props: {
            type: 'text',
            clearable: true,
            placeholder: 'user@email.com',
          },
          rules: {
            // required: true,
            pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
          },
          messages: {
            required: '请输入投资者邮箱',
            pattern: '邮箱不合法',
          },
        },
        {
          type: 'input',
          modelKey: 'managersLanline',
          label: '座机',
          props: {
            type: 'tel',
            clearable: true,
            maxlength: 20,
            placeholder: '请输入座机号码',
          },
          rules: {
            // required: true,
            notWhitespace: true,
            pattern: /\d{1,20}/,
          },
          messages: {
            required: '请输入座机号码',
            pattern: '座机不合法',
          },
        },
        {
          type: 'input',
          modelKey: 'managersMobile',
          label: '手机',
          props: {
            type: 'tel',
            // readonly: true,
          },
        },
        {
          type: 'input',
          modelKey: 'managersZip',
          label: '邮编',
          props: {
            type: 'number',
            clearable: true,
            placeholder: '请输入邮编',
          },
          rules: {
            // required: true,
            notWhitespace: true,
            pattern: /^[0-9]{6}$/,
          },
          messages: {
            required: '请输入邮编',
            pattern: '邮编不合法',
          },
        },
        {
          type: 'textarea',
          modelKey: 'managersAddress',
          label: '住址',
          props: {
            maxlength: 100,
            indicator: false,
            placeholder: '请输入住址',
          },
          rules: {
            // required: true,
            notWhitespace: true,
          },
          messages: {
            required: '请输入住址',
          },
        },
        {
          type: 'textarea',
          modelKey: 'relationshipWithOrg',
          label: '与该机构关系',
          props: {
            maxlength: 20,
            indicator: false,
            placeholder: '请输入与该机构关系',
          },
          rules: {
            // required: true,
            notWhitespace: true,
          },
          messages: {
            required: '请输入与该机构关系',
          },
        },
      ],
    };
  },
  watch: {
    'Model.isManagerValidateForever': {
      handler(val) {
        if (val) {
          this.Model.managersDocumentsValidity = '永久有效';
        } else {
          this.Model.managersDocumentsValidity = null;
        }
      },
      immediate: false,
    },
  },
  methods: {
    /**
     * 通过身份证号码计算性别和年龄
     * @param  {[type]} val [description]
     * @return {[type]}     [description]
     */
    $_getAgeAndSex(val) {
      if (val && val.length === 18) {
        const strBirthday = `${val.substr(6, 4)}/${val.substr(10, 2)}/${val.substr(12, 2)}`;
        const birthDate = new Date(strBirthday);
        const nowDateTime = new Date();
        let age = nowDateTime.getFullYear() - birthDate.getFullYear();
        if (nowDateTime.getMonth() < birthDate.getMonth()
        || (nowDateTime.getMonth() === birthDate.getMonth()
        && nowDateTime.getDate() < birthDate.getDate())) {
          age -= 1;
        }
        const Sex = Number(val.substring(16, 17));

        this.Model.managersAge = age;
        this.Model.managersSex = Sex % 2 === 0 ? '女' : '男';
      } else {
        this.Model.managersAge = null;
        this.Model.managersSex = null;
      }
    },
    /**
     * 选择证件有效期
     * @return {[type]} [description]
     */
    $_handleShowManagersDocumentsValidityPicker() {
      if (this.Model.isManagerValidateForever) return;
      this.$createDatePicker({
        title: '证件有效期',
        min: new Date(1999, 12, 1),
        max: new Date(2099, 11, 31),
        format: {
          year: 'YYYY',
          month: 'MM',
          date: 'DD',
        },
        value:
          this.Model.managersDocumentsValidity
            ? new Date(this.Model.managersDocumentsValidity)
            : new Date(),
        onSelect: (date, selectedVal, selectedText) => {
          this.$set(this.Model, 'managersDocumentsValidity', selectedText.join('-'));
        },
        onCancel: () => {
        },
      }).show();
    },
  },
};
export default mixin;
